import { Typography } from '@material-ui/core';
import React from 'react';
import { DemoButton } from '../components/DemoButton';
import {
  FeatureAffiliateApis,
  FeatureAffiliateDashboard,
  FeatureAuthors,
  FeatureCardGrid,
  FeatureContentAnalytics,
  FeatureConversionHeatmaps,
  FeatureCustomIntegrations,
  FeatureExports,
  FeatureIntegrations,
  FeatureLinkGenerator,
  FeatureLinkManagement,
  FeaturePayouts,
  FeatureRates,
  FeatureRevenueAttribution,
  FeatureRevisionTracking,
  FeatureRoles,
  FeatureSegmentation,
  FeatureTeams,
  FeatureTrafficSources
} from '../components/FeatureGrid';
import { Headline } from '../components/Headline';
import PageHead from '../components/PageHead';
import { SEO } from '../components/SEO';
import MainLayout from '../layouts/main';

export default () => {
  return (
    <MainLayout>
      <div>
        <SEO
          pathname="/product/"
          title="Affiliate Tracking for Publishers · Affilimate Features"
          description=""
        />
        <PageHead>
          <Headline
            variant="h1"
            gutterBottom
            component="h1"
            style={{
              maxWidth: '600px',
              margin: '0 auto 36px'
            }}
          >
            Affiliate growth tools for leading publishers
          </Headline>
          <Typography
            variant="body1"
            color="textSecondary"
            style={{ maxWidth: '600px', margin: '24px auto 0' }}
          >
            Tap into the most powerful commerce growth platform used by leading
            publishers and at scale. Find revenue opportunities in your existing
            content, links, and partnerships with tools like these.
          </Typography>
        </PageHead>
        <Headline
          variant="h3"
          gutterBottom
          component="h2"
          style={{
            textAlign: 'center'
          }}
        >
          Content insights and optimization
        </Headline>
        <Typography
          variant="body1"
          color="textSecondary"
          style={{
            maxWidth: '510px',
            margin: '24px auto 12px',
            textAlign: 'center'
          }}
        >
          Editor-friendly tools that teams will actually adopt and use to
          improve content performance.
        </Typography>
        <FeatureCardGrid>
          <FeatureContentAnalytics />
          <FeatureSegmentation />
          <FeatureRevenueAttribution />
          <FeatureConversionHeatmaps />
          <FeatureTrafficSources />
          <FeatureRevisionTracking />
        </FeatureCardGrid>
        <Headline
          variant="h3"
          gutterBottom
          component="h2"
          style={{
            textAlign: 'center'
          }}
        >
          Workflow and collaboration
        </Headline>
        <Typography
          variant="body1"
          color="textSecondary"
          style={{
            maxWidth: '510px',
            margin: '24px auto 12px',
            textAlign: 'center'
          }}
        >
          Improve efficiency and eliminate errors with team collaboration and
          link management tools.
        </Typography>
        <FeatureCardGrid>
          <FeatureAuthors />
          <FeatureLinkGenerator />
          <FeatureRates />
          <FeatureLinkManagement />
          <FeatureTeams />
          <FeatureRoles />
        </FeatureCardGrid>
        <Headline
          variant="h3"
          gutterBottom
          component="h2"
          style={{
            textAlign: 'center'
          }}
        >
          Reporting and finance
        </Headline>
        <Typography
          variant="body1"
          color="textSecondary"
          style={{
            maxWidth: '510px',
            margin: '24px auto 12px',
            textAlign: 'center'
          }}
        >
          Track your revenue, commissions, and payouts with ease.
        </Typography>
        <FeatureCardGrid>
          <FeatureAffiliateDashboard />
          <FeatureAffiliateApis />
          <FeaturePayouts />
          <FeatureExports />
          <FeatureIntegrations />
          <FeatureCustomIntegrations />
        </FeatureCardGrid>
        <Headline
          variant="h4"
          gutterBottom
          component="h2"
          style={{
            fontWeight: 900,
            textAlign: 'center'
          }}
        >
          Discover even more...
        </Headline>
        <Typography
          variant="body1"
          color="textSecondary"
          style={{
            maxWidth: '510px',
            margin: '24px auto 12px',
            textAlign: 'center'
          }}
        >
          Discover more ways publishers are growing with Affilimate by booking a
          demo with our team today.
          <br />
          <br />
          <DemoButton variant="contained" />
        </Typography>
        <br />
        <br />
      </div>
    </MainLayout>
  );
};
